import React, { useEffect, useState } from 'react';
import { Lock, Flag, AlertCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const PASSWORD = 'westvalley2026';
const STORAGE_KEY = 'wvpac_authed';
interface PasswordGateProps {
  children: React.ReactNode;
}
export function PasswordGate({
  children
}: PasswordGateProps) {
  const [authed, setAuthed] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined' && sessionStorage.getItem(STORAGE_KEY) === 'true') {
      setAuthed(true);
    }
    setChecked(true);
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input === PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setAuthed(true);
      setError(false);
    } else {
      setError(true);
    }
  };
  if (!checked) return null;
  if (authed) return <>{children}</>;
  return <div className="min-h-screen bg-pac-navy flex items-center justify-center px-4 relative overflow-hidden" data-id="element-178">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-179" />
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-pac-gold/10 blur-3xl" data-id="element-180" />
      <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full bg-pac-red/10 blur-3xl" data-id="element-181" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="relative z-10 w-full max-w-md" data-id="element-182">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-8" data-id="element-183">
          <Flag className="h-10 w-10 text-pac-gold" data-id="element-184" />
          <div className="flex flex-col" data-id="element-185">
            <span className="font-serif font-bold text-2xl leading-tight text-white tracking-wide uppercase" data-id="element-186">
              West Valley
            </span>
            <span className="text-xs font-sans font-semibold text-pac-gold tracking-[0.2em] uppercase" data-id="element-187">
              Leadership PAC
            </span>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8 border border-slate-200" data-id="element-188">
          <div className="flex items-center justify-center w-14 h-14 bg-pac-navy rounded-full mx-auto mb-6" data-id="element-189">
            <Lock className="h-6 w-6 text-pac-gold" data-id="element-190" />
          </div>

          <h1 className="font-serif text-3xl font-bold text-pac-navy text-center mb-2" data-id="element-191">
            Private Preview
          </h1>
          <p className="text-slate-600 text-center mb-8 text-sm" data-id="element-192">
            This site is password protected. Please enter the access code to
            continue.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-193">
            <div data-id="element-194">
              <label htmlFor="password" className="sr-only" data-id="element-195">
                Password
              </label>
              <input id="password" type="password" autoFocus value={input} onChange={e => {
              setInput(e.target.value);
              setError(false);
            }} placeholder="Enter password" className={`w-full px-4 py-3 border-2 rounded font-medium outline-none transition-all ${error ? 'border-pac-red bg-red-50 focus:border-pac-red' : 'border-slate-200 focus:border-pac-blue'}`} data-id="element-196" />
              {error && <div className="flex items-center gap-2 mt-2 text-pac-red text-sm font-medium" data-id="element-197">
                  <AlertCircle className="h-4 w-4" data-id="element-198" />
                  <span data-id="element-199">Incorrect password. Please try again.</span>
                </div>}
            </div>

            <button type="submit" className="w-full bg-pac-red hover:bg-red-800 text-white py-3.5 rounded font-bold uppercase tracking-wider transition-all shadow-[0_4px_14px_0_rgba(185,28,28,0.39)] hover:-translate-y-0.5" data-id="element-200">
              Access Site
            </button>
          </form>
        </div>

        <p className="text-center text-slate-400 text-xs mt-6" data-id="element-201">
          Authorized personnel only.
        </p>
      </motion.div>
    </div>;
}